import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ScheduleEF from './ScheduleEF'
import request from 'superagent';


class ScheduleEFController extends Component {
  static propTypes = {
    case_uuid: PropTypes.string.isRequired,
    canEdit: PropTypes.bool.isRequired,
  }

  constructor(props) {
    super(props);

    // State is given to <ScheduleEF> as props
    this.state = {
      canEdit: props.canEdit,
      loading: true,
      schedule_ef: {},
    }
  }

  render() {
    return <ScheduleEF
      {...this.state}
      onSaveSchedule={ value => { this.saveSchedule(value) }  }
    />
  }


  componentDidMount() {
    this.fetchSchedule();
  }

  fetchSchedule() {
    console.log(`Fetching Schedule EF for ${this.props.case_uuid}`);
    this.setState({loading: true});

    const component = this;

    component.setState({
      ...component.state,
      loading: true,
    });

    return request
      .get(`/scheduleform/get-part/${this.props.case_uuid}/schedule_ef`)
      .then(
        function onSuccess(response) {
          console.log("onSuccess", arguments);
          if (response.status !== 200) {
            return onFailure(response.message || 'service error');
          }

          component.setState({
            loading: false,
            schedule_ef: response.body,
          });
        },
        function onFailure(errorMessage) {
          console.log("onFailure", arguments);

          component.setState({
            ...component.state,
            loading: false,
          });

          // extract useful message if possible
          try {
            errorMessage = errorMessage.response.body.error.errorMessage
          }
          catch (and_ignore) {
          }

          alert(`Error Loading!\n\n${errorMessage}`);
        }
      );
  }


  saveSchedule(values) {
    console.log('New Values', values);

    const component = this;

    component.setState({
      ...component.state,
      loading: true,
      schedule_ef: { data: values }, // don't lose values in case of error
      // TODO: draft values should be saved and handled separately....
    });


    function onSuccess(response) {
      console.log("onSuccess", arguments);
      if (response.status !== 200) {
        return onFailure(response.message || 'service error');
      }

      component.setState({
        ...component.state,
        loading: false,
        schedule_ef: response.body.content.queries[0].schedule_ef[0].text, // server will provide new version of schedule
      });
    }

    function onFailure(errorMessage) {
      console.log("onFailure", arguments);
      component.setState({
        ...component.state,
        loading: false,
      });
      // extract useful message if possible
      try {
        errorMessage = errorMessage.response.body.error.errorMessage
      }
      catch (and_ignore) {
      }

      alert(`Error Saving!\n\n${errorMessage}`);
    }

    return request
      .post('/scheduleform/save')
      .send({
        type: 'ef',
        case_uuid: this.props.case_uuid,
        data: values
      })
      .then(onSuccess, onFailure);
  }

}


export default ScheduleEFController;


//    data: {
//       priority_creditors: [
//         {
//           "basis_claim": "Taxes NOTICE",
//           "creditor": "IRS\nP.O. Box 7346\nPhiladelphia, PA 19101",
//           "debt_date": "",
//           "is_contingent": "",
//           "is_disputed": "",
//           "is_subject_to_offset": "",
//           "is_unliquidated": "",
//           "priority_amount": "12000.00",
//           "total_claim": "0.00"
//         },
//       ],
//       non_priority_creditors: [
//         {
//           "basis_claim": "accounting work",
//           "creditor": "Buchanan's Accounting & Tax Service\n537 Royal Palm Beach Blvd.\nWest Palm Beach, FL 33411",
//           "debt_date": "various",
//           "is_contingent": "",
//           "is_disputed": "",
//           "is_subject_to_offset": "",
//           "is_unliquidated": "",
//           "priority_amount": "",
//           "total_claim": "$990.00"
//         },
//         {
//           "basis_claim": "Repairs - 5.30.17 $2,033.04, 7.5.2017 $930.64, 1.12.17 $875.65,7.18.16 $285.00",
//           "creditor": "Commerical Truck Repair\n837 West 13th Street\nWest Palm Beach, FL 33404",
//           "debt_date": "various",
//           "is_contingent": "",
//           "is_disputed": "",
//           "is_subject_to_offset": "",
//           "is_unliquidated": "",
//           "priority_amount": "",
//           "total_claim": "$4,124.33"
//         },
//         {
//           "basis_claim": "loans to company",
//           "creditor": "Ernest Burrs Jr\n2642 West 28th Street\nRivera Beach, FL 33404",
//           "debt_date": "",
//           "is_contingent": "",
//           "is_disputed": "",
//           "is_subject_to_offset": "",
//           "is_unliquidated": "",
//           "priority_amount": "",
//           "total_claim": "Unknown"
//         }
//       ]
//     }


/** WEBPACK FOOTER **
 ** ./src/scheduleform/ScheduleEFController.jsx
 **/